import React from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import {loadSession, setLoading} from "@app/common/store/action";
import * as Yup from "yup";
import get from "lodash/get";
import {Grid, TextField} from "@material-ui/core";
import {  withRouter } from "react-router-dom";
import { firstTimeChangePasswordService} from '@app/common/services/firsttimechangepasswordservice'
import {

    CHG_PWD_SUC, CHG_PWD_SUC_TITLE,
    FIRST_TIME_CHANGE_PASSWORD_200,
    FIRST_TIME_CHANGE_PASSWORD_201
} from "@app/common/constants/constants";
import ErrorTextContainer from "../../../../components/errortextcontainer/errortextcontainer";
import { FIRST_TIME_CHANGE_PASSWORD_ROUTE, LOGIN_ROUTE, MFA_SETUP_ROUTE} from "../../../../constants/routeconstants";
import {changePasswordService} from "@app/common/services/changepasswordservice";
import TwoButtonContainer from "../../../../components/twobuttoncontainer/twobuttoncontainer";
import {
    PASSWORD_COMPLEXITY_ERR,
    PASSWORD_FAILURE_STATUS,
    PASSWORD_SUCCESSFUL_STATUS, PASSWORD_TO_MATCH,
    SUBMIT,
    SUCCESS, USER_NAME_REQUIRED
} from "../../../../constants/appconstants";

import style from "./changepasswordform.module.css";
import TextFieldToolTip from "../../../../components/textfieldtooltip/textfieldtooltip";
import {LOADING_FAILURE_STATUS, LOADING_SUCCESS_STATUS} from "../../../../components/loading/constants";

class ChangePasswordForm extends React.Component {

    constructor(props) {
        super(props);
        const path = get(props, "location.pathname");
        this.state = {
            showError: 0,
            message:"",
            openDialog:false,
            dialogText:"",
            dialogTitle:"",
            errorText:"",
            isFirstTime:path===FIRST_TIME_CHANGE_PASSWORD_ROUTE
        };
    }

    closePage = (isSubmit) =>()=> {
        const prevPath = get(this, "props.location.state.prevPath");
        console.log("prevPath",prevPath)
        if(prevPath){
            isSubmit?
            this.setState({
               openDialog:true
            }): this.props.history.push(prevPath);

        }else{
            let searchParams = new URLSearchParams(window.location.search)
            let param = searchParams.get('backurl')
            if(param){
                window.history.back()
            } else{
                this.props.history.push(LOGIN_ROUTE);
            }
        }
    };

    submitAction = (fields) => {
      const {isFirstTime} = this.state;
      console.log("changepassword isFirstTime",isFirstTime)
      const {actions} =  this.props;
      actions.setLoading(true);
      if(isFirstTime)
          this.firstTimeChangePasswordSubmit(fields)
      else
          this.changePasswordSubmit(fields)
    };

    changePasswordSubmit = async(fields)=>{
        const { actions } = this.props;
        try{
            await changePasswordService(fields);
            actions.setLoading(false,LOADING_SUCCESS_STATUS,PASSWORD_SUCCESSFUL_STATUS,"",true);
            this.setState({dialogText:CHG_PWD_SUC,openDialog:true,dialogTitle:CHG_PWD_SUC_TITLE})
            let searchParams = new URLSearchParams(window.location.search)
            let param = searchParams.get('backurl')
            if(param){
                window.history.back()
            } else{
                this.props.history.push(LOGIN_ROUTE);
            }


        }catch(e){
            // this.setState({dialogText:e,openDialog:true,dialogTitle:"Session Expired"})
            actions.setLoading(false,LOADING_FAILURE_STATUS,PASSWORD_FAILURE_STATUS,"",true);
            this.setState({errorText:e});
        }
    }
    firstTimeChangePasswordSubmit = async (fields)=>{
        const { actions,session } = this.props;
        try{
            let response = await firstTimeChangePasswordService(fields,session);
            let serviceResponseHeader = get(response,"serviceResponseHeader");
            let serviceResponseBody = get(response,"serviceResponseBody");
            let statusCode = get(serviceResponseHeader,"statusCode");
            let mfaSession  =get(serviceResponseBody,"session");
            console.log("statusCode",statusCode)
            if (statusCode === FIRST_TIME_CHANGE_PASSWORD_200) {
                actions.setLoading(false,LOADING_SUCCESS_STATUS,PASSWORD_SUCCESSFUL_STATUS,"",true);
                this.setState({dialogText:CHG_PWD_SUC,openDialog:true,dialogTitle:CHG_PWD_SUC_TITLE})
            }else if(statusCode === FIRST_TIME_CHANGE_PASSWORD_201){
                actions.setLoading(false,LOADING_SUCCESS_STATUS,PASSWORD_SUCCESSFUL_STATUS,"",true);
                this.props.actions.loadSession(mfaSession)
                this.props.history.push({pathname:MFA_SETUP_ROUTE,state:{status:SUCCESS}})
            }else{
                console.log("else method")
                actions.setLoading(false);
            }

        }catch(e){
            // this.setState({dialogText:e,openDialog:true,dialogTitle:"Session Expired"})
            actions.setLoading(false,LOADING_FAILURE_STATUS,PASSWORD_FAILURE_STATUS,"",true);
            this.setState({errorText:e});
        }
    }

    // getError = ()=>{
    //     const {showError} = this.state;
    //     if(showError === 1) {
    //         return    <label>Invalid username or current password.</label>
    //     }else if(showError === 2) {
    //         return   <label>
    //             The new password cannot be same as last 3 passwords.
    //         </label>
    //     }else if (showError === 3) {
    //        return  <label>
    //             Unknown error occured.Please contact administrator.
    //         </label>
    //     }else
    //         return null
    // }
    handleDialogClose = ()=>{
        const prevPath = get(this, "props.location.state.prevPath");
        this.props.history.push(prevPath)
    }
    render() {
        const userName = get(this, "props.location.state.userName");
        const openDialog = get(this,"state.openDialog")
        const dialogText= get(this,"state.dialogText")
        const dialogTitle= get(this,"state.dialogTitle")
        const isFirstTime= get(this,"state.isFirstTime")

        return (

                        <Formik
                            initialValues={{
                                userName: userName,
                                currentPassword: "",
                                newPassword: "",
                                confirmPassword: "",
                            }}
                            validationSchema={Yup.object().shape({
                                userName: isFirstTime?Yup.string().required(USER_NAME_REQUIRED):null,
                                currentPassword:isFirstTime?null: Yup.string().required(
                                    "Current Password is required"
                                ),
                                newPassword: Yup.string()
                                    .test(
                                        "password match with old",
                                        "New password must not be same as old password",
                                        function (pass) {
                                            const {currentPassword} = this.parent;
                                            if(isFirstTime) return true
                                            return !(currentPassword !== undefined &&
                                                currentPassword === pass);

                                        }
                                    )
                                    .test(
                                        "password contains userid",
                                        "The new password cannot include username.",
                                        function (pass) {
                                                if(!isFirstTime) return true
                                                const {userName} = this.parent;
                                                return !(userName !== undefined && pass !== undefined && pass.includes(userName));


                                        }
                                    )
                                    .matches(
                                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{12,}$/,
                                        PASSWORD_COMPLEXITY_ERR
                                    )
                                    .required("New Password is required"),

                                confirmPassword: Yup.string()
                                    .oneOf([Yup.ref("newPassword"), null], PASSWORD_TO_MATCH)
                                    .required("Confirm Password is required"),
                            })}
                            onSubmit={(fields) => {
                                console.log("onSubmit1234 fields",fields)
                                this.submitAction(fields);
                            }}
                            render={({errors, touched, values,handleChange}) => (
                                <Form style={{minWidth: "330px"}}>
                                    <Grid container direction={"column"}>
                                        <Grid item>
                                            <div className={style.change_password_form_error}>
                                                <ErrorTextContainer text={this.state.errorText}/>
                                            </div>
                                        </Grid>
                                        <Grid item className={style.change_password_text_field_spacing}/>

                                        {isFirstTime?<Grid item
                                               className={style.change_password_form_text_field_container}>
                                            <TextField
                                                id={"outlined-basic"}
                                                name="userName"
                                                variant={"outlined"}
                                                label={"Username"}
                                                onChange={handleChange}
                                                type="text"
                                                className={style.change_password_form_text_field}
                                                value={values.userName}
                                                error={errors.userName && touched.userName}
                                                helperText={touched.userName && errors.userName}

                                            />
                                        </Grid>:null}

                                        {isFirstTime?null:<Grid item className={style.change_password_form_text_field_container}>
                                            <TextField
                                                id={"outlined-basic"}
                                                name="currentPassword"
                                                InputLabelProps={this.state.currentPasswordShrink?{ style: { pointerEvents: "auto" } }:null}
                                                // label={"currentPassword"}
                                                label={
                                                    <div>
                                                        Current Password
                                                        {this.state.currentPasswordShrink ?<TextFieldToolTip text={PASSWORD_COMPLEXITY_ERR}/>:null}
                                                    </div>}
                                                onFocus={()=>{
                                                    this.setState({currentPasswordShrink:true})
                                                    }
                                                }
                                                onBlur={() => {

                                                        this.setState({currentPasswordShrink: false})
                                                    }
                                                }


                                                variant={"outlined"}
                                                onChange={handleChange}
                                                type="password"
                                                className={style.change_password_form_text_field}
                                                error={errors.currentPassword && touched.currentPassword}
                                                helperText={touched.currentPassword && errors.currentPassword}
                                            />
                                        </Grid>}

                                    <Grid item className={style.change_password_form_text_field_container}>

                                        <TextField
                                            id={"outlined-basic"}
                                            name="newPassword"
                                            type="password"
                                            variant={"outlined"}
                                            InputLabelProps={this.state.newPasswordShrink?{ style: { pointerEvents: "auto" } }:null}

                                            onChange={handleChange}
                                            label={
                                                <div>
                                                    New Password
                                                    {this.state.newPasswordShrink ?<TextFieldToolTip text={PASSWORD_COMPLEXITY_ERR}/>:null}
                                                </div>}
                                            onFocus={()=>{
                                                this.setState({newPasswordShrink:true})
                                            }
                                            }
                                            onBlur={() => {

                                                this.setState({newPasswordShrink: false})
                                            }
                                            }
                                            className={style.change_password_form_text_field}
                                            error={errors.newPassword && touched.newPassword}
                                            helperText={touched.newPassword && errors.newPassword}
                                        />

                                    </Grid>
                                    <Grid item className={style.change_password_form_text_field_container}>
                                        <TextField
                                            id={"outlined-basic"}
                                            name="confirmPassword"
                                            variant={"outlined"}
                                            InputLabelProps={this.state.confirmPasswordShrink?{ style: { pointerEvents: "auto" } }:null}

                                            label={
                                                <div>
                                                    Confirm Password
                                                    {this.state.confirmPasswordShrink ?<TextFieldToolTip text={PASSWORD_COMPLEXITY_ERR}/>:null}
                                                </div>}
                                            onFocus={()=>{
                                                this.setState({confirmPasswordShrink:true})
                                            }
                                            }
                                            onBlur={() => {

                                                this.setState({confirmPasswordShrink: false})
                                            }
                                            }
                                            onChange={handleChange}
                                            type="password"
                                            className={style.change_password_form_text_field}
                                            error={errors.confirmPassword && touched.confirmPassword}
                                            helperText={touched.confirmPassword && errors.confirmPassword}
                                        />
                                    </Grid>

                                            <Grid item>
                                                <TwoButtonContainer title={SUBMIT}

                                                                    onCloseRequestHandler={this.closePage(false)}/>

                                            </Grid>
                                    </Grid>
                                </Form>
                            )}
                        />

        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    session:state.session,

});


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ setLoading,loadSession }, dispatch),
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps),withRouter)(ChangePasswordForm);
